import { Component, HostListener, OnInit } from "@angular/core";
import { ActivatedRoute, Router, NavigationEnd } from "@angular/router";
import { ManualsService } from "src/app/services/manuals/manuals.service";
import { environment } from "../../../environment/environment";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { filter } from "rxjs/operators";
import { saveAs } from "file-saver";
import { catchError, map } from "rxjs/operators";
import Swal from "sweetalert2";

export enum KEY_CODE {
  RIGHT_ARROW = 39,
  LEFT_ARROW = 37,
  print_screen = 44,
  inspectelement = 123,
}

@Component({
  selector: "app-manuals",
  templateUrl: "./manuals.component.html",
  styleUrls: ["./manuals.component.css"],
})
export class ManualsComponent implements OnInit {
  postObj: any;
  ProjectId: any;
  clientId: any;
  manualList: any;
  projectDetails: any;
  ProjectManualsName: any;
  folderArray: any;
  apipath: any;
  pmsUrl: any;
  action: any;
  imageurl: any;
  otherurl: any;
  audiourl: any;
  videourl: any;
  codecs: any;
  content: any;
  showLi: boolean = true;
  folderId: any;
  customerActionLogsId: any;
  user_id: any;
  isMainUser: any;
  manualListData: boolean = false;
  @HostListener("document:contextmenu", ["$event"])
  RightClick(event: any) {
    event.preventDefault();
    return false;
  }

  @HostListener("contextmenu", ["$event"])
  onRightClick(event: any) {
    event.preventDefault();
  }

  @HostListener("window:keyup", ["$event"])
  keyEvent(event: KeyboardEvent) {
    // console.log(event);
    // console.log("KEY_CODE.RIGHT_ARROW" + KEY_CODE.RIGHT_ARROW);
    if (event.keyCode === KEY_CODE.RIGHT_ARROW) {
      event.stopPropagation();
      event.preventDefault();
    }

    if (event.keyCode === KEY_CODE.LEFT_ARROW) {
      alert("here");
      event.stopPropagation();
      event.preventDefault();
    }
    if (
      event.keyCode == KEY_CODE.print_screen ||
      event.keyCode == KEY_CODE.inspectelement
    ) {
      event.stopPropagation();
      event.preventDefault();
    }
  }
  constructor(
    private route: ActivatedRoute,
    private ManualsService: ManualsService,
    private router: Router,
    private modalService: NgbModal
  ) {
    this.loadScript("../assets/scripts/main.d810cf0ae7f39f28f336.js");
  }
  ngOnInit(): void {
    this.customerActionLogsId = localStorage.getItem("customerActionLogsId");
    this.user_id = localStorage.getItem("user_id");
    this.clientId = localStorage.getItem("customerId");
    this.isMainUser = localStorage.getItem("isMainUser");

    // this.route.params.subscribe((params) => {
    //   this.loadComponentData(1);
    // });
    // Subscribe to route params
    this.route.params.subscribe((params) => {
      this.manualListData = false;
      this.manualList = [];
      this.projectDetails = [];
      this.ProjectManualsName = environment.projectName;
      this.folderArray = [];
      this.ProjectId = params["id"]; // Get the ProjectId from the route parameters
      this.folderId = params["folderId"]; // Get the folderId from the route parameters (if available)
      console.log(
        "Navigated to ProjectId:",
        this.ProjectId,
        "FolderId:",
        this.folderId
      );
      this.loadComponentData(1); // Call loadComponentData with the appropriate argument
    });
  }
  loadScript(scriptUrl: string) {
    const script = document.createElement("script");
    script.src = scriptUrl;
    document.body.appendChild(script);
  }
  loadComponentData(showLiCondition: any) {
    if (showLiCondition == 1) {
      this.showLi = false;
    }
    this.apipath = environment.url.substr(0, environment.url.lastIndexOf("/"));
    this.pmsUrl = environment.pmsUrl.substr(
      0,
      environment.pmsUrl.lastIndexOf("/")
    );
    console.log("this.pmsUrl--->", this.pmsUrl);

    this.ProjectId = this.route.snapshot.paramMap.get("id");

    if (this.route.snapshot.paramMap.get("folderId") != null) {
      if (showLiCondition == 2) {
        this.router.navigate(["/manuals/", this.ProjectId]);
      }
      this.showLi = true;
    }
    this.folderId = this.route.snapshot.paramMap.get("folderId");

    console.log("this.ProjectId", this.ProjectId);
    console.log("this.folderId", this.folderId);

    if (this.folderId == null) {
      this.postObj = {
        customer_id: this.clientId,
        project_id: this.ProjectId,
        customerActionLogsId: this.customerActionLogsId,
        user_id: this.user_id,
        isMainUser: this.isMainUser,
      };
    } else {
      this.postObj = {
        customer_id: this.clientId,
        project_id: this.ProjectId,
        folder_id: this.folderId,
      };
    }

    this.ManualsService.getmanuallist(this.postObj).subscribe((res: any) => {
      console.log("response --- " + res.data);
      if (res.code == 1) {
        if (!res.data) {
          this.manualListData = false;
        } else {
          this.manualListData = true;
          this.manualList = res.data;
          this.projectDetails = res.projectDetails;
          this.ProjectManualsName = this.projectDetails.name;
          this.folderArray = res.folderArray;
          console.log("folderArray data:", this.folderArray);
        }
      } else {
      }
    });
  }
  openFolderOnHeader(element: any) {
    this.showLi = true;
    let folder_id = element.id;
    this.postObj = {
      customer_id: this.clientId,
      project_id: this.ProjectId,
      folder_id: folder_id,
    };
    this.getmanuallistFuncation();
  }

  openSubFolderLoad() {
    this.showLi = true;
    if (this.folderId != "") {
      this.postObj = {
        customer_id: this.clientId,
        project_id: this.ProjectId,
        folder_id: this.folderId,
      };
      this.getmanuallistFuncation();
    }
  }

  openSubFolder(element: any) {
    this.showLi = true;
    this.folderId = element.id;
    if (element.type == "folder") {
      this.postObj = {
        customer_id: this.clientId,
        project_id: this.ProjectId,
        folder_id: this.folderId,
      };
      this.getmanuallistFuncation();
    }
  }

  // getmanuallistFuncation() {
  //   this.ManualsService.getmanuallist(this.postObj).subscribe((res: any) => {
  //     // console.log("response sub --- " + res.response);
  //     if (res.code == 1) {
  //       this.manualList = res.data;
  //       this.projectDetails = res.projectDetails;
  //       this.ProjectManualsName = this.projectDetails.name;
  //       this.folderArray = res.folderArray;
  //     } else {
  //       // this.flashMessage = "Something went wrong!";
  //       // this.flashType = "error";
  //       // this.flashActive = "flashblock";
  //     }
  //   });
  // }

  getmanuallistFuncation() {
    this.ManualsService.getmanuallist(this.postObj).subscribe((res: any) => {
      if (res.code === 1) {
        // Case: Folder contains data
        this.manualList = res.data;
        this.projectDetails = res.projectDetails;
        this.ProjectManualsName = this.projectDetails?.name;
        this.folderArray = res.folderArray;

        // Log for debugging
        console.log("Folder contains data:", this.manualList);
      } else if (res.code === 0) {
        // Case: Folder is empty
        Swal.fire({
          icon: "info",
          title: "Folder is empty",
          text: res.message || "No items were found in this folder.",
        });
      } else {
        // Case: Unexpected error
        // Swal.fire({
        //   icon: 'error',
        //   title: 'Error',
        //   text: 'Something went wrong while fetching the folder contents.',
        // });
      }
    });
  }

  // Function to extract file extension from the file name
  getFileExtension(fileName: string): string {
    const parts = fileName.split(".");
    if (parts.length > 1) {
      return parts[parts.length - 1].toLowerCase();
    }
    return ""; // Return an empty string if there's no extension
  }

  // Function to create the image path based on the file extension
  getImagePath(fileName: string): string {
    const extension = this.getFileExtension(fileName);
    // console.log("extension--->", extension);

    if (extension) {
      var filePath = `assets/images/icon/${extension}.png`;

      // this.ManualsService.checkFileExistence(filePath).subscribe((exists) => {
      //   if (exists) {
      //     console.log("File exists");
      //   } else {
      //     console.log("File does not exist");
      //   }
      // });
      return `assets/images/icon/${extension}.png`;
    }
    return "assets/images/icon/documents.png"; // Use a default image for unknown extensions
  }
  downloadDocument1(content: any, element: any) {
    const file_name = element.document_name;
    const file_path = `${this.apipath}/${element.document_path}/${file_name}`;

    // Determine the file type based on the file URL
    const fileType = this.getFileType(file_path);

    // Create a hidden anchor element to trigger the download
    const a = document.createElement("a");
    a.style.display = "none";
    document.body.appendChild(a);

    // Set the anchor's attributes
    a.href = file_path;
    a.download = `downloaded.${fileType}`;

    // Trigger a click event on the anchor element to initiate the download
    a.click();

    // Clean up the anchor element
    document.body.removeChild(a);
  }

  downloadDocument(content: any, element: any) {
    // console.log("element--->", element);

    const file_name = element.document_name;
    const id = element.id;
    var type = element.type;
    if (type == "folder") {
      var url = environment.url + `ApiGM/downloadFolder&id=` + id;
      window.open(url, "_blank");
    } else {
      const file_path = `${this.apipath}/${element.document_path}/${file_name}`;
      // Trigger the download using FileSaver
      saveAs(file_path, `downloaded.${this.getFileType(file_name)}`);
    }
  }

  getFileType(url: string): string {
    console.log("url--->", url);

    const parts = url.split(".");
    return parts[parts.length - 1].toLowerCase();
  }

  openDocument(content: any, element: any) {
    const folderId = element.id;
    const fileName = element.document_name;
    const filePath = `${this.pmsUrl}/${element.document_path}/${fileName}`;
    console.log("fileName--->", fileName);
    console.log("filePath--->", filePath);

    // const encodedFilePath = encodeURIComponent(filePath1);
    // console.log("filepath1--->", filePath1);
    // const filePath = encodedFilePath;
    const fileType = fileName.split(".").pop()?.toLowerCase() || "";
    let finalPath = "";
    let imagepath = "";
    let audiopath = "";
    let videopath = "";
    let codecs = "";

    console.log("File Type:", fileType);

    const isImage = ["png", "jpg", "gif"].includes(fileType);
    const isPdf = fileType === "pdf";
    const isDoc = [
      "doc",
      "docx",
      "ppt",
      "pptx",
      "xls",
      "xlsx",
      "ods",
      "odt",
    ].includes(fileType);
    const isAudio = ["mp3", "wav"].includes(fileType);
    const isVideo = ["mp4", "m4v", "mov", "wmv"].includes(fileType);
    const isCad = ["dwg", "dxf", "dft"].includes(fileType);
    const isExcel = ["xls", "xlsx", "ods"].includes(fileType); // NEW
    const isOdt = ["odt"].includes(fileType); // NEW

    if (isExcel) {
      // this.downloadFile(filePath, fileName);
      // finalPath = `https://docs.google.com/gview?url=${filePath}&embedded=true`;
      finalPath = `https://view.officeapps.live.com/op/view.aspx?src=${filePath}`;
      this.opendoc(finalPath);
      return; // stop further execution
    }
    if (isOdt) {
      // this.downloadFile(filePath, fileName);
      finalPath = `https://view.officeapps.live.com/op/view.aspx?src=${filePath}`;
      this.opendoc(finalPath);
      // finalPath = `https://docs.google.com/gview?url=${filePath}&embedded=true`;
      return; // stop further execution
    }

    if (isImage) {
      imagepath = filePath;
      this.openmodal(
        content,
        imagepath,
        finalPath,
        audiopath,
        videopath,
        codecs
      );
    } else if (isPdf || isDoc) {
      const encodedFilePath = encodeURIComponent(`${filePath}&embedded=true`);
      finalPath = `https://docs.google.com/gview?url=${filePath}&embedded=true`;
      // finalPath = `https://docs.google.com/gview?url=${encodedFilePath}`;
      this.opendoc(finalPath);
    } else if (isAudio) {
      audiopath = filePath;
      this.openmodal(
        content,
        imagepath,
        finalPath,
        audiopath,
        videopath,
        codecs
      );
    } else if (isVideo) {
      if (fileType === "m4v") {
        codecs = "avc1.42E01E, mp4a.40.2";
      }
      videopath = filePath;
      this.openmodal(
        content,
        imagepath,
        finalPath,
        audiopath,
        videopath,
        codecs
      );
    } else if (isCad) {
      finalPath = `https://sharecad.org/cadframe/load?url=${filePath}`;
      this.opendoc(finalPath);
    } else {
      finalPath = filePath;
      this.opendoc(finalPath);
    }
  }

  opendoc(filepath: any) {
    console.log("filepath--->", filepath);
    var url = `${this.pmsUrl}/index.php?r=customerSoFolder/opendocument&file_path=${filepath}&embedded=true`;

    console.log("url--->", url);
    // var url =
    // "https://grindmaster.disctesting.in/index.php?r=customerSoFolder/opendocument&file_path=https://docs.google.com/gview?url=https://grindmaster.disctesting.in/uploads/SO_1_143/test/sample.xlsx&embedded=true";

    // return false;

    // window.open(this.action + "&file_path=" + filepath, '_blank');
    // this.action = this.ManualsService.open_document();
    // window.open(this.action+'/load_document.php?file_path=' + filepath, '_blank');
    window.open(`${url}`, "_blank");
  }
  openmodal(
    content: any,
    imagepath: any,
    finalpath: any,
    audiopath: any,
    videopath: any,
    codecs: any
  ) {
    // console.log("open modal");
    this.imageurl = imagepath;
    this.otherurl = finalpath;
    this.audiourl = audiopath;
    this.videourl = videopath;
    this.codecs = codecs;
    this.modalService.open(content, { centered: true });
  }

  handleImageError(event: Event) {
    // Handle image loading error by changing the source to a fallback image
    const imageElement = event.target as HTMLImageElement;
    imageElement.src = "assets/images/icon/documents.png";
  }
  downloadFile(url: string, filename: string) {
    const link = document.createElement("a");
    link.href = url;
    link.download = filename; // ensures download
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

}